<template>
  <v-card class="white answer-card pa-1">
    <v-card-text class="pa-1">
      <v-layout>
        <v-btn-toggle class="answer-btns pa-0" text v-model="answerAnswer">
          <v-btn
            :disabled="!userCanEdit"
            text
            :class="{ 'mx-0': true, fresh: answerAnswer ? false : true }"
            v-for="answer in answers"
            :value="answer.value"
            :key="answer.value"
          >
            <v-layout wrap>
              <v-flex xs12>
                <svg width="18" height="18">
                  <pattern
                    :id="`hatchCard${answer.value}`"
                    patternUnits="userSpaceOnUse"
                    width="4"
                    height="4"
                  >
                    <path
                      d="M-1,1 l2,-2
                      M0,4 l4,-4
                      M3,5 l2,-2"
                      :style="`stroke:${answer.color}; stroke-width:1`"
                    />
                  </pattern>
                  <circle
                    :stroke="answer.color"
                    stroke-width="2"
                    :fill="hasFill ? answer.color : `url(#hatchCard${answer.value})`"
                    r="8"
                    cx="9"
                    cy="9"
                  ></circle>
                </svg>
              </v-flex>
              <v-flex xs12 class="answer-title">
                <div>{{ answer.text[0] }}<br />{{ answer.text[1] }}</div>
              </v-flex>
            </v-layout>
          </v-btn>
        </v-btn-toggle>
      </v-layout>
      <v-divider class="py-2"></v-divider>
      <v-layout>
        <v-btn-toggle class="confidence-btns pa-0" text v-model="confidenceAnswer">
          <v-btn
            :disabled="!userCanEdit"
            text
            :class="{ 'mx-0': true, fresh: confidenceAnswer ? false : true }"
            :value="1"
          >
            <svg width="30" height="30">
              <circle
                :stroke="color"
                stroke-width="2"
                :fill="`url(#hatchCard${answerAnswer})`"
                r="14"
                cx="15"
                cy="15"
              ></circle>
            </svg>
            <div class="answer-title pl-2">...but not sure yet</div>
          </v-btn>
          <v-btn
            :disabled="!userCanEdit"
            text
            :class="{ 'mx-0': true, fresh: confidenceAnswer ? false : true }"
            :value="2"
          >
            <svg width="30" height="30"><circle :fill="color" r="14" cx="15" cy="15"></circle></svg>
            <div class="answer-title pl-2">...and I'm pretty sure</div>
          </v-btn>
        </v-btn-toggle>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import authorAnswerColors from './mixins/authorAnswerColors';
import { mapGetters } from 'vuex';
export default {
  props: ['value'],
  mixins: [authorAnswerColors],
  computed: {
    ...mapGetters('context', ['userCanEdit']),
    color() {
      return this.answerAnswer ? this.colors[this.answerAnswer] : this.colors[0];
    },
    hasFill() {
      return !this.answerAnswer || this.confidenceAnswer == 2;
    },
    answerAnswer: {
      set: function(v) {
        console.log(v);
        const value = v ? v : 0;
        return this.$emit('input', { answer: value });
      },
      get: function() {
        return this.value.answer;
      }
    },
    confidenceAnswer: {
      set: function(v) {
        const value = v ? v : 0;
        return this.$emit('input', { confidence: value });
      },
      get: function() {
        return this.value.confidence;
      }
    }
  }
};
</script>

<style scoped>
.answer-btns .v-btn {
  height: 80px !important;
  border: none !important;
  opacity: 0.6;
}

.v-btn.fresh {
  opacity: 0.9 !important;
}

.answer-btns .v-item--active,
.confidence-btns .v-item--active {
  opacity: 1 !important;
}

.answer-btns {
  box-shadow: none;
}

.answer-title {
  font-size: 12px;
}

.confidence-btns {
  box-shadow: none;
  width: 100%;
}

.confidence-btns .v-btn {
  height: 50px !important;
  width: 50%;
  opacity: 0.6;
  border: none !important;
}

.answer-btns .v-btn--disabled,
.confidence-btns .v-btn--disabled {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
